import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {CourseVideo} from "../../models/course-video";
import {CourseModule} from "../../models/course-module";

/**
 * Generated class for the AppVideoTipsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-video-tips',
  templateUrl: 'app-video-tips.html',
})
export class AppVideoTipsPage {

  video: CourseVideo;
  module: CourseModule;
  tipps: Array<string>;
  template: string;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.video = (this.navParams.data as any).video;
    this.module = (this.navParams.data as any).module;
    this.template = this.navParams.get('template');
    if(this.template == 'practice') {
      this.tipps = (this.module.practiceTips?this.module.practiceTips:'').split("\n").filter(row => {return row;});
    } else {
      this.tipps = (this.module.quizTips?this.module.quizTips:'').split("\n").filter(row => {return row;});
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppVideoTipsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-video-tips/app-video-tips.ts